import React from "react";

interface IProps {
    title?: string;
    description?: string;
    children?: React.ReactNode;
    style?: React.CSSProperties;
}

export default function FormBlock(props: IProps) {
    return (
        <div className="userful-form-block" style={props.style}>
            {(props.title || props.description) && (
                <div className="userful-form-block-text">
                    {props.title && <h1>{props.title}</h1>}
                    {props.description && <p>{props.description}</p>}
                </div>
            )}
            {props.children}
        </div>
    );
}
